import type { ReactNode } from 'react'
import { Navigate } from 'react-router-dom'
import type { PersonaKey } from '@/shared/domain'
import { useCurrentPersona } from '@/shared/ui/hooks'
import { AppShellSkeleton } from '@/shared/ui/layout/app-shell-skeleton'

type RequirePersonaProps = {
  allowed: PersonaKey[]
  children: ReactNode
}

export function RequirePersona({ allowed, children }: RequirePersonaProps) {
  const { persona, isLoading } = useCurrentPersona()

  if (isLoading) return <AppShellSkeleton testId="persona-loading" />

  if (!allowed.includes(persona)) {
    return <Navigate to="/no-access" replace />
  }

  return <>{children}</>
}
